import React from 'react';
import { Button } from 'modules/v2/common/AtomicDesign/atoms';

const PreviewModal = ({ isOpen, onClose, template, onCustomize }) => {
  if (!isOpen || !template) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" onClick={onClose}>
      <div className="bg-white flex flex-col items-center rounded-lg w-6/12 max-h-[90vh] overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="w-full p-4 border-b flex justify-between items-center">
          <h2 className="text-xl font-semibold">{template.template_title || template.project_title || 'Preview'}</h2>

          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="w-full bg-neutral-200 p-6 overflow-y-auto max-h-[calc(90vh-180px)]">
          <img
            src={template.smartThumbnailUrl || template.thumbnail_url}
            alt={template.template_title || template.project_title}
            className="object-contain place-self-center"
          />
        </div>
        <div className="w-full p-4 border-t flex justify-end">
          <Button
            onClick={() => {
              onClose();
              onCustomize(template);
            }}
          >
            {template.project_id ? 'Open Project' : 'Customize Template'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PreviewModal;